import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Button, FormHelperText, TextField } from "@material-ui/core";
import useAuth from "../../../hooks/useAuth";
import useMounted from "../../../hooks/useMounted";
import toast from "react-hot-toast";
import authService from "src/UIS_services/AuthenticationService/authService";
const ChangePassword: FC = () => {
    const mounted = useMounted();
    const { passwordRecovery } = useAuth() as any;
    const navigate = useNavigate();

    return (
        <Formik
            initialValues={{
                PasswordOld: "",
                PassWordNew1: "",
                PasswordNew2: "",
                submit: null,
            }}
            validationSchema={Yup.object().shape({
                PasswordOld: Yup.string().required("Mật khẩu cũ là bắt buộc"),
                PassWordNew1: Yup.string().required("Mật khẩu mới là bắt buộc"),
                PasswordNew2: Yup.string().oneOf(
                    [Yup.ref("PassWordNew1"), null],
                    "Mật khẩu phải trùng khớp"
                ),
            })}
            onSubmit={async (
                values,
                { setErrors, setStatus, setSubmitting }
            ): Promise<void> => {
                try {
                    let body = {
                        p1: values.PasswordOld,
                        p2: values.PassWordNew1,
                    };
                    let res = await authService.ChangePassword(body);
                    if (res) {
                        toast.success(res.Message);
                    }
                } catch (err) {
                    console.error(err);
                    if (mounted.current) {
                        setStatus({ success: false });
                        setErrors({ submit: err.message });
                        setSubmitting(false);
                    }
                }
            }}
        >
            {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values,
            }): JSX.Element => (
                <form noValidate onSubmit={handleSubmit}>
                    <TextField
                        autoFocus
                        error={Boolean(
                            touched.PasswordOld && errors.PasswordOld
                        )}
                        fullWidth
                        helperText={touched.PasswordOld && errors.PasswordOld}
                        label="Mật khẩu cũ"
                        margin="normal"
                        name="PasswordOld"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="password"
                        value={values.PasswordOld}
                        variant="outlined"
                    />
                    <TextField
                        autoFocus
                        error={Boolean(
                            touched.PassWordNew1 && errors.PassWordNew1
                        )}
                        fullWidth
                        helperText={touched.PassWordNew1 && errors.PassWordNew1}
                        label="Mật khẩu mới"
                        margin="normal"
                        name="PassWordNew1"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="password"
                        value={values.PassWordNew1}
                        variant="outlined"
                    />
                    <TextField
                        autoFocus
                        error={Boolean(
                            touched.PasswordNew2 && errors.PasswordNew2
                        )}
                        fullWidth
                        helperText={touched.PasswordNew2 && errors.PasswordNew2}
                        label="Nhập lại mật khẩu mới"
                        margin="normal"
                        name="PasswordNew2"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="password"
                        value={values.PasswordNew2}
                        variant="outlined"
                    />
                    {errors.submit && (
                        <Box sx={{ mt: 3 }}>
                            <FormHelperText error>
                                {errors.submit}
                            </FormHelperText>
                        </Box>
                    )}
                    <Box sx={{ mt: 3 }}>
                        <Button
                            color="primary"
                            disabled={isSubmitting}
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                        >
                            Đổi mật khẩu
                        </Button>
                    </Box>
                </form>
            )}
        </Formik>
    );
};

export default ChangePassword;
